import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "components/ui/popover";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { X } from "lucide-react";

export default function PricePopover() {
  const [isOpen, setIsOpen] = useState(false);

  // Internal input state
  const [minInput, setMinInput] = useState("0");
  const [maxInput, setMaxInput] = useState("0");

  // Final applied state
  const [minPrice, setMinPrice] = useState<number | null>(null);
  const [maxPrice, setMaxPrice] = useState<number | null>(null);

  const handleApply = () => {
    const min = parseInt(minInput) || 0;
    const max = parseInt(maxInput) || 0;
    setMinPrice(min);
    setMaxPrice(max);
    setIsOpen(false);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    setMinPrice(null);
    setMaxPrice(null);
    setMinInput("0");
    setMaxInput("0");
  };

  const getDisplayLabel = () => {
    if (minPrice !== null && maxPrice !== null && (minPrice > 0 || maxPrice > 0)) {
      return `${minPrice} - ${maxPrice}`;
    }
    return "Price";
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          💰 {getDisplayLabel()}
          {minPrice !== null && maxPrice !== null && (minPrice > 0 || maxPrice > 0) && (
            <X size={14} className="text-muted-foreground hover:text-destructive" onClick={handleClear} />
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-80 p-4 space-y-4">
        <div className="text-sm font-semibold">Price</div>

        <div className="flex items-center gap-2">
          <Input type="number" placeholder="Min" value={minInput} onChange={(e) => setMinInput(e.target.value)} />
          <span className="text-xl font-light">–</span>
          <Input type="number" placeholder="Max" value={maxInput} onChange={(e) => setMaxInput(e.target.value)} />
        </div>

        <Button className="w-full" onClick={handleApply}>
          Apply Filter
        </Button>
      </PopoverContent>
    </Popover>
  );
}

